import { MenuItem, TextField } from "@mui/material"
import React from "react"
import { FilterProps } from "react-table"


//This control should not be used for Server Side Filtering. The list is pulled from memory. 
//If a Select Filter is needed a new filter component will need to be created and a list will need to be provided of possible values.
export function ServerSelectColumnFilter<T extends Record<string, unknown>>({
    column: { filterValue, render, setFilter, filterOptions}}: FilterProps<T>,

){

    return (
      <TextField
        select
        label={render('Header')}
        value={filterValue || ''}
        onChange={(e) => {
          setFilter(e.target.value || undefined)
        }}
        variant='standard'
      >
        <MenuItem value={''}>All</MenuItem>
        {filterOptions?.map((option, i) => (
          <MenuItem key={i} value={option.value}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
    )
  }